import GradientTextSection from "./Components/GradientTextSection";
import LandingPageCarousel from "./Components/LandingPageCarousel";
import TitleWithStar from "../../Shared/TitleWithStar";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import Button from "react-bootstrap/Button";
import Container from "react-bootstrap/Container";
import GradientCard from "./Components/GradientCard";
import HeroSectionWithText from "./Components/HeroSectionWithText";
import TriplePictureTextSection from "./Components/TriplePictureTextSection";
import GradientCardSection from "./Components/GradientCardSection";
import ContactUsSection from "./Components/ContactUsSection";
import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";

const LandingPage = () => {
  const navigate = useNavigate();
  const { t } = useTranslation();

  return (
    <div className={"p-0"}>
      <LandingPageCarousel></LandingPageCarousel>
      <TitleWithStar text={t("landing.home.whatWeDo")} className={"mt-5"}></TitleWithStar>

      <GradientCardSection></GradientCardSection>
      <TitleWithStar text={t("landing.home.ourDifference")} className={"mt-5"}></TitleWithStar>

      <HeroSectionWithText imageSrc={"/LandingPageImages/girlWithLaptopSitting.webp"}>
        {t("landing.home.differenceText1")}
      </HeroSectionWithText>

      <HeroSectionWithText isImageOnRight={true} imageSrc={"/LandingPageImages/satisfiedCustomers.webp"}>
        {t("landing.home.differenceText2")}
      </HeroSectionWithText>

      <TitleWithStar text={t("landing.home.aboutUs")} className={"mt-5 mb-5"}></TitleWithStar>

      {/* Founders Section */}
      <Container className="mb-5">
        <Row className="justify-content-center text-center">
          <Col lg={8}>
            <div className="founders-cta-section py-5">
              <h3 className="mb-4" style={{ fontSize: "2rem", fontWeight: "600", color: "#2c3e50" }}>
                {t("landing.home.foundersTitle")}
              </h3>
              <p className="mb-4" style={{ fontSize: "1.1rem", color: "#6c757d", lineHeight: "1.6" }}>
                {t("landing.home.foundersDescription")}
              </p>
              <Button
                size="lg"
                onClick={() => navigate("/founders")}
                style={{
                  background: "linear-gradient(135deg, #667eea 0%, #764ba2 100%)",
                  border: "none",
                  borderRadius: "12px",
                  padding: "1rem 2.5rem",
                  fontSize: "1.1rem",
                  fontWeight: "500",
                  boxShadow: "0 8px 20px rgba(102, 126, 234, 0.3)",
                  transition: "all 0.3s ease",
                }}
                onMouseOver={(e) => {
                  e.target.style.transform = "translateY(-3px)";
                  e.target.style.boxShadow = "0 12px 30px rgba(102, 126, 234, 0.4)";
                }}
                onMouseOut={(e) => {
                  e.target.style.transform = "translateY(0)";
                  e.target.style.boxShadow = "0 8px 20px rgba(102, 126, 234, 0.3)";
                }}
              >
                {t("landing.home.foundersButton")}
              </Button>
            </div>
          </Col>
        </Row>
      </Container>

      <TriplePictureTextSection
        firstImageSrc={"/LandingPageImages/planningTeam.webp"}
        secondImageSrc={"/LandingPageImages/laptopWithStatistics.webp"}
        thirdImageSrc={"/LandingPageImages/girlUsingLaptop.webp"}
        firstText={t("landing.home.aboutText1")}
        secondText={t("landing.home.aboutText2")}
        thirdText={t("landing.home.aboutText3")}
      ></TriplePictureTextSection>

      <ContactUsSection></ContactUsSection>
    </div>
  );
};

export default LandingPage;
